import PageHeader from "@/components/PageHeader";
import Platters from "@/components/Platters";
import CtaBand from "@/components/CtaBand";
import { useSeo } from "@/lib/seo";

export default function MenuPage() {
  useSeo({
    title: "Food & Platters Menu | Cool Runnings Cape Town",
    description:
      "Hearty party platters, party packs and kids feasts for your day at Cool Runnings Toboggan Park, Cape Town.",
    keywords:
      "Cool Runnings menu, party platters Cape Town, party packs, kids party food Cape Town, family restaurant Tygervalley, halaal platters Cape Town",
    image: "/og/menu.jpg",
  });
  return (
    <>
      <PageHeader
        goodgirlTitle
        pageName="Food & Platters"
        eyebrow="The Full Menu"
        title="FOOD & PLATTERS"
        subline="Party platters, party packs and kids feasts for your day at the park."
        image="/food-platters.jpg"
      />
      <Platters />
      <CtaBand />
    </>
  );
}
